module.exports = __webpack_public_path__ + "static/media/zola-weddings-logo-black.83c28c85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/zola-weddings-logo-black.svg
// module id = 1615
// module chunks = 46